var isRelease = process.env.VUE_APP_IS_RELEASE == 1

module.exports = {
  title: "vava",
  version: "1.0.0",
  isRelease: isRelease,
  lang: "zh-CN",
  imgHost: isRelease ? 'https://source.camfan.chat/' : 'https://source.camfan.chat/',
  apiBaseURL: isRelease ? "api.camfan.chat" : "app.test.camfan.chat",
  // apiBaseURL: isRelease ? "api.camfan.chat" : "api.camfan.chat",  // 测试线上问题
  address: isRelease ? 'www.vava.chat' : 'app.test.camfan.chat',   // vava=goparty 域名
  addressJoychat: isRelease ? 'app.joyme.chat' : 'd3iaj0r7mc0gy4.cloudfront.net', //joychat 域名
  addressEcho: isRelease ? 'dewidfp7zx5np.cloudfront.net' : 'dewidfp7zx5np.cloudfront.net', //echo 域名

  addressPackage: isRelease ? 'com.client.goparty' : 'com.example.gcc', // vava=goparty 包名
  addressJoychatPackage: isRelease ? 'com.chat.joychat' : 'com.owner.chat', // joychat 包名

  // 错误 性能上报接口
  errorUploadUrl: isRelease ? `https://api.camfan.chat/api/v2/comm/h5/info` : `https://app.test.camfan.chat/api/v2/comm/h5/info`,
};